export const TIER_TOKEN_COST: Record<string, number> = {
  compact:   3,
  midsize:   5,
  executive: 10,
  luxury:    25,
};

export const BP_TOKEN_COST = 1;
